<template>
  <base-section id="about-us">
    <base-section-heading
      color="grey lighten-2"
      title="Visi dan Misi"
    />

    <v-container>
      <v-row>
        <v-col
          v-for="card in cards"
          :key="card.title"
          cols="12"
          md="6"
        >
          <base-info-card v-bind="card" />
        </v-col>
      </v-row>
    </v-container>
  </base-section>
</template>

<script>
  export default {
    name: 'SectionAboutUs',

    data: () => ({
      cards: [
        {
          title: 'Visi',
          text: 'Menjadi pemimpin dalam industri asuransi umum syariah Indonesia.',
          callout: '01',
        },
        {
          title: 'Misi',
          text: 'Menerapkan prinsip-prinsip syariah dalam pengelolaan risiko sehingga memberikan maslahah kepada seluruh stakeholder.',
          callout: '02',
        },
      ],
    }),
  }
</script>
